import React from 'react';
import {connect} from 'react-redux';
import NoComments from './shared/noComments/noComments';
import Comments from './shared/comments/comments';
import NotSignedInDialog from './shared/notSignedInDialog/notSignedInDialog';
import AddComment from './shared/addComment/addComment';
import EditCommentBy from './shared/editComment/EditCommentBy'
import {setUpdatingComment, updateCommentChange} from './../../redux/actions';

class LikesCommentsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            comment: {}
        }
    }

    /**
     * Params { Boolean } flag
     * Params { Object } comment
     * Does: Shows / hides comment box and set initial values for edit comment
     */
    onEdit = (flag, comment) => {
        if (!flag) {
            this.setState({
                edit: flag,
                comment: {}
            });
            this.props.setUpdatingComment(false);
            return;
        }
        this.setState({
            edit: flag,
            comment: comment
        });
        this.props.updateCommentChange(comment);
        this.props.setUpdatingComment(true);

        this.scrollTo(document.body, 300, 0);

    }

    onSubmit = (body) => {
    }


    scrollTo = (element, to, duration) => {
        var start = element.scrollTop,
            change = to - start,
            currentTime = 0,
            increment = 20;

        var animateScroll = () => {
            currentTime += increment;
            var val = this.easeInOutQuad(currentTime, start, change, duration);
            element.scrollTop = val;
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    }

    easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    };

    render() {
        const {fetchedUsersData, userId} = this.props.user;
        const {comment} = this.state;
        const {offset, loadingGetComment} = this.props.comments;
        if (offset === 0 && loadingGetComment) {
            return 'Loading Comment View...'
        }
        return (<div>
            {
                fetchedUsersData && !userId &&
                <NotSignedInDialog/>
            }

            {
                this.props.comments.comments && this.props.comments.comments.length > 0 &&
                <Comments
                    loadMore={this.props.loadMore}
                    onEdit={this.onEdit}
                    userId={this.props.userId}
                    originalSharedProjectGuid={this.props.originalSharedProjectGuid}/>


            }
            {/* 
            {
                helpers.isMobile() && !this.props.user.userId &&
                <label>Only people invited to this project can see these messages. </label>
            } */}

            {
                !this.props.comments.updatingComment && userId &&
                <AddComment
                    originalSharedProjectGuid={this.props.originalSharedProjectGuid}/>
            }

            {
                !(this.props.comments.comments && this.props.comments.comments.length > 0) &&
                <NoComments userName={this.props.userName}/>
            }
            {
                this.props.comments.updatingComment && userId &&
                <div id="edit-comment-scroll-area">
                    <EditCommentBy
                        onEdit={this.onEdit}
                        onSubmit={this.onSubmit}
                        comment={comment}
                        originalSharedProjectGuid={this.props.originalSharedProjectGuid}/>
                </div>
            }

        </div>)
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        comments: state.comments
    }
}

export default connect(mapStateToProps, {updateCommentChange, setUpdatingComment})(LikesCommentsContainer);